import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { DepositPaymentPage } from '@/components/deposit-payment/deposit-payment-page'

const depositSearchSchema = z.object({
  email: z.string().optional(),
  lastName: z.string().optional(),
  dossierNumber: z.string().optional(),
  // Moyen de règlement visé : le PDF de contrat et l'espace client pointent vers
  // `...&mode=installments` pour ouvrir directement le paiement en 3/4x.
  mode: z.enum(['installments']).optional(),
})

export const Route = createFileRoute('/_blue_header/payer-acompte/')({
  component: RouteComponent,
  validateSearch: depositSearchSchema,
})

function RouteComponent() {
  const searchParams = Route.useSearch()

  return <DepositPaymentPage initialValues={searchParams} mode={searchParams.mode} />
}
